/**
 *  @class
 *  @function AccountForms
 */
if (!customElements.get('account-forms')) {
  class AccountForms extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['data-panel'];
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-panel' && newValue) {
        this.openPanel(newValue);
      }
    }

    openPanel(panelId) {
      const panels = this.querySelectorAll('.account-form-panel');
      const toggles = this.querySelectorAll('.account-form-toggle');

      panels.forEach((panel) => {
        if (panel.id === panelId) {
          panel.classList.add('is-open');
        } else {
          panel.classList.remove('is-open');
        }
      });

      toggles.forEach((toggle) => {
        if (toggle.getAttribute('aria-controls') === panelId) {
          toggle.setAttribute('aria-expanded', true);
        } else {
          toggle.setAttribute('aria-expanded', false);
        }
      });
    }

    handleClick(event) {
      const accordion = event.currentTarget;
      const currentToggle = event.target.closest('.account-form-toggle');
      if (!currentToggle) return;
      const panelId = currentToggle.getAttribute('aria-controls');
      const currentPanel = accordion.querySelector(`#${panelId}`);
      const toggles = accordion.querySelectorAll('.account-form-toggle');
      const panels = accordion.querySelectorAll('.account-form-panel');

      toggles.forEach((toggle) => {
        if (toggle !== currentToggle) {
          toggle.setAttribute('aria-expanded', false);
        }
      });
      panels.forEach((panel) => {
        if (panel === currentPanel) {
          const ariaState = currentToggle.getAttribute('aria-expanded');
          if (ariaState === 'true') {
            currentToggle.setAttribute('aria-expanded', false);
            panel.classList.remove('is-open');
          } else {
            currentToggle.setAttribute('aria-expanded', true);
            panel.classList.add('is-open');
            const drawerModalInner = currentPanel.closest('.drawer-modal__inner');
            if (drawerModalInner) {
              drawerModalInner.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            }
          }
        } else {
          panel.classList.remove('is-open');
        }
      });
    }
  }
  customElements.define('account-forms', AccountForms);
}
